import { gql } from '@apollo/client'
import { ADMIN_STORE_FRAGMENT_WITH_POG } from '../fragments/AdminStoreFragmentWithPOG'

export const GET_ADMIN_COMPANY_STORES_WITH_POG = gql`
  query AdminCompanyStoresWithPOG($input: AdminCompanyStoresInput!) {
    adminCompanyStores(input: $input) {
      hasMore
      count
      results {
        ...AdminStoreWithPOG
      }
    }
  }
  ${ADMIN_STORE_FRAGMENT_WITH_POG}
`
